export default ({ session: { groupId } }) => ({
  currentProviderId: groupId,
});
